import React, { Fragment } from 'react';
import {
  Show,
  TabbedShowLayout,
  Tab,
  DateField,
  ReferenceField,
  TextField,
  Datagrid,
  FunctionField,
  ListButton,
  ArrayField,
  EditButton,
} from 'react-admin';
import CardActions from '@material-ui/core/CardActions';

import FullNameField from '../General/FullNameField';
import SendCampaignToMailchimp from './SendCampaignToMailchimp';

import { getAdminLevel, ADMIN_LEVELS } from '../../authProvider';
import { offeringCategory } from '../../helpers/mappings';


const Title = ({ record }) => (
  <span>Offer Order #{record.id}</span>
);

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};


const Actions = ({
  basePath,
  data,
  resource,
}) => {
  const adminLevel = getAdminLevel();

  return (
    <CardActions style={cardActionStyle}>
      {/* {
        data && adminLevel && adminLevel !== ADMIN_LEVELS.READ_ONLY_ADMIN ?
          <Fragment>
            <SendTestCampaignToMailchimp resource={resource} record={data} />
          </Fragment> : undefined
      } */}
      {
        data && adminLevel && adminLevel !== ADMIN_LEVELS.READ_ONLY_ADMIN ?
          <Fragment>
            <SendCampaignToMailchimp resource={resource} record={data} />
          </Fragment> : undefined
      }
      {
        data && !['sent', 'created'].includes(data.status) && <EditButton record={data} basePath={basePath} />
      }
      <ListButton basePath={basePath} />
    </CardActions>
  );
};

export default props => (
  <Show
    {...props}
    actions={<Actions path={props.location.pathname} />}
    title={<Title />}
  >
    <TabbedShowLayout>
      <Tab label="Offer Campaign Details">
        <ReferenceField label="User" source="userId" reference="users" linkType="show">
          <FullNameField />
        </ReferenceField>
        <DateField source="createdAt" />
        <DateField source="updatedAt" />
        <TextField label="Name" source="offer.name" />
        <TextField source="status" />
        <FunctionField
          label="Offer Category"
          render={record => `${record.isConditionalOffer ? offeringCategory.CONDITIONAL.label : offeringCategory.NORMAL.label}`}
        />
      </Tab>
      <Tab label="Subscribers Email List">
        <ArrayField label="" source="members">
          <Datagrid>
            <TextField source="email" label="Email" />
            <TextField source="status" label="Status" />
          </Datagrid>
        </ArrayField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);



// WEBPACK FOOTER //
// ./src/components/OfferCampaign/Show.js